
// export const myGetter = ( state ) => {
//  return state
// }

export const productlotList = state => state.productlot
export const productlotSelectable = state => state.productlotSelectable
export const productlotPaginatedData = state => state.productlotPaginatedData
export const productlot = state => state.productlot
export const isLoading = state => state.isLoading
export const isCreating = state => state.isCreating
export const isUpdating = state => state.isUpdating
export const createdData = state => state.createdData
export const updatedData = state => state.updatedData
export const isDeleting = state => state.isDeleting
export const deletedData = state => state.deletedData
export const isFindingProductlot = state => state.isFindingProductlot
export const findProductlot = state => state.findProductlot

export const productlotListByClientSelectable = state => state.productlotListByClientSelectable
export const isLoadingProductlotListByClient = state => state.isLoadingProductlotListByClient

export const findProductlotExist = state => state.findProductlotExist